import React from 'react'
import { Field } from 'redux-form'

import { Input as TextInput } from 'components'

export const Input = ({ name, label, inputRef = () => { }, ref, ...other }) => (
  <Field
    fullWidth
    name={name}
    label={label}
    margin='normal'
    component={TextInput}
    InputProps={{
      inputRef: node => {
        ref(node);
        inputRef(node);
      }
    }}
    {...other}
  />
)


// WEBPACK FOOTER //
// ./src/components/Autocomplete/components/Input/Input.js